import { Grid, Typography } from "@material-ui/core";
import { CardExpired } from "../styles/GrupoInformacoes";

const ExpiredCard = ({
  icon = null,
  bottomColor = "unset",
  countDays = "",
  countLabel = "",
  bottomDescription = "",
}) => {
  return (
    <CardExpired bottomColor={bottomColor}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={2}>
          <Typography
            style={{ fontWeight: 800, fontSize: 20, textAlign: "center" }}
          >
            {countDays}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography
            style={{
              fontSize: 18,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {countLabel}
          </Typography>
        </Grid>
        <Grid item xs={12} md={2} container justifyContent="center">
          {icon && icon}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 12,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {bottomDescription}
          </Typography>
        </Grid>
      </Grid>
    </CardExpired>
  );
};

export default ExpiredCard;
